/**
 * @Author: Anandp
 * @Date:   2024-04-17 18:40:49
 * @Last Modified by:   Anandp
 * @Last Modified time: 2025-01-13 22:44:23
 */
export const amplifyConfig = {
  aws_project_region: process.env.REACT_APP_AWS_PROJECT_REGION,
  aws_cognito_identity_pool_id:
    process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID,
  aws_cognito_region: process.env.REACT_APP_AWS_COGNITO_REGION,
  aws_user_pools_id: process.env.REACT_APP_AWS_USER_POOLS_ID,
  aws_user_pools_web_client_id:
    process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID,
};

export const auth0Config = {
  base_url: process.env.REACT_APP_AUTH0_BASE_URL,
  client_id: process.env.REACT_APP_AUTH0_CLIENT_ID,
  issuer_base_url: process.env.REACT_APP_AUTH0_ISSUER_BASE_URL,
};

export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
};

export const gtmConfig = {
  containerId: process.env.REACT_APP_GTM_CONTAINER_ID,
};

export const mapboxConfig = {
  apiKey: process.env.REACT_APP_MAPBOX_API_KEY,
};

export const downloadDashboard = true;
export let Url = "";
export let PdFUrl = "";
export let CmsUrl = "";
export let explorerImageUrl = "";
if (window.location.host === "dev-customer.sl-ivl.com") {
  Url = "https://api-dev.sl-ivl.com";
  PdFUrl = "https://api-dev.sl-ivl.com";
  CmsUrl = "https://sld-strapi.sl-ivl.com/api";
  explorerImageUrl = "https://sld-strapi.sl-ivl.com";
} else if (window.location.host === "dev-customer-datamigration.sl-ivl.com") {
  Url = "https://az56cn4erf.execute-api.ap-southeast-2.amazonaws.com/dev";
  PdFUrl = "https://az56cn4erf.execute-api.ap-southeast-2.amazonaws.com/dev";
  CmsUrl = "https://sld-strapi.sl-ivl.com/api";
  explorerImageUrl = "https://sld-strapi.sl-ivl.com";
} else if (window.location.host === "sl-load-test-customer.sl-ivl.com") {
  Url = "https://2swud8yia0.execute-api.ap-southeast-2.amazonaws.com/dev";
  PdFUrl = "https://2swud8yia0.execute-api.ap-southeast-2.amazonaws.com/dev";
  CmsUrl = "https://prod-strapi.sl-ivl.com/api";
  explorerImageUrl = "https://prod-strapi.sl-ivl.com";
} else if (window.location.host === "stage-customer.sl-ivl.com") {
  Url = "https://api-stage.sl-ivl.com";
  PdFUrl = "https://api-stage.sl-ivl.com";
  CmsUrl = "https://sld-strapi.sl-ivl.com/api";
  explorerImageUrl = "https://sld-strapi.sl-ivl.com";
} else if (window.location.host === "qa-customer.sl-ivl.com") {
  Url = "https://api-qa.sl-ivl.com";
  PdFUrl = "https://api-qa.sl-ivl.com";
  CmsUrl = "https://sld-strapi.sl-ivl.com/api";
  explorerImageUrl = "https://sld-strapi.sl-ivl.com";
} else if (window.location.host === "train-customer.sl-ivl.com") {
  Url = "https://training-api.sl-ivl.com";
  PdFUrl = "https://training-api.sl-ivl.com";
  CmsUrl = "https://sld-strapi.sl-ivl.com/api";
  explorerImageUrl = "https://sld-strapi.sl-ivl.com";
} else if (window.location.host === "test.sl-ivl.com") {
  Url = "https://test.sl-ivl.com/api";
  PdFUrl = "https://test.sl-ivl.com/api";
  CmsUrl = "https://sld-strapi.sl-ivl.com/api";
  explorerImageUrl = "https://sld-strapi.sl-ivl.com";
} else if (window.location.host === "stage.sl-ivl.com") {
  Url = "https://stage.sl-ivl.com/api";
  PdFUrl = "https://stage.sl-ivl.com/api";
  CmsUrl = "https://sld-strapi.sl-ivl.com/api";
  explorerImageUrl = "https://sld-strapi.sl-ivl.com";
} else if (window.location.host === "integratedtesting-customer.sl-ivl.com") {
  Url = "https://lpy48q0ygi.execute-api.ap-southeast-2.amazonaws.com/dev";
  PdFUrl = "https://lpy48q0ygi.execute-api.ap-southeast-2.amazonaws.com/dev";
  CmsUrl = "https://sld-strapi.sl-ivl.com/api";
  explorerImageUrl = "https://sld-strapi.sl-ivl.com";
} else if (window.location.host === "temp-dev-customer.sl-ivl.com") {
  Url = "https://api-temp.sl-ivl.com";
  PdFUrl = "https://api-temp.sl-ivl.com";
  CmsUrl = "https://sld-strapi.sl-ivl.com/api";
  explorerImageUrl = "https://sld-strapi.sl-ivl.com";
}else if (window.location.host === "mysmartleader.com") {
  Url = "https://api.mysmartleader.com";
  PdFUrl = "https://api.mysmartleader.com";
  CmsUrl = "https://cms.mysmartleader.com/api";
  explorerImageUrl = "https://cms.mysmartleader.com";
}
else {
  Url = "http://localhost:8080";
  PdFUrl = "https://1qp1gktax0.execute-api.ap-southeast-2.amazonaws.com/dev";
  CmsUrl = "https://sld-strapi.sl-ivl.com/api";
  explorerImageUrl = "https://sld-strapi.sl-ivl.com";
}

// export let bearerToken = "";

export let bearerToken = sessionStorage.getItem("strapiKey")?.replace(/"/g, '');
const strapiKey = sessionStorage.getItem("strapiKey");
function tryParseJSON(jsonString) {
  try {
    const parsed = JSON.parse(jsonString);
    // Optional: ensure it's an object or expected type
    if (parsed && typeof parsed === "object") {
      return parsed;
    }
  } catch (e) {
    // Ignore error
  }
  return null;
}
if (strapiKey && strapiKey !== "undefined") {

  const parsed = tryParseJSON(strapiKey);
  bearerToken = parsed || strapiKey;
} else {
  const userDetails = sessionStorage.getItem("userDetails");
  if (userDetails && userDetails !== "undefined") {
    const parsedUserDetails = JSON.parse(userDetails);
    if (parsedUserDetails && parsedUserDetails.strapiKey) {
      bearerToken = parsedUserDetails.strapiKey;
    }
  }
};
export const siteConstant = {
  AZURE_CONFIG_STORAGE_KEY: "azure-config",
  GOOGLE_CONFIG_STORAGE_KEY: "google-config",
  AUTH_ISSUER_STORAGE_KEY: "issuer",
  AUTH_TOKEN_STORAGE_KEY: "accessToken",
  AUTH_PROFILE_STORAGE_KEY: "userDetails",
};

export const RECAPTCHA_KEY = "6LceKHEpAAAAAIHsclSv3YMyeq_eiAe5B3WwOXuN";
export const MEMBER_ROLE_ID = 102;
export const _063_QUESTION_IDS = {
  WhatToDoToTakeStep: 412,
  WhatCanDoToImprove: 410,
  WhatAchieved: 300,
  HowToImprove: 407,
  WhatAreStrengths: 301
}
// export let CmsUrl = "https://sld-strapi.sl-ivl.com/api";
// export let explorerImageUrl = "https://sld-strapi.sl-ivl.com";
